<template>
  <div>
    <v-card style="min-height: 800px">
      <v-card-title v-show="!sharedDataStore.isMobile()" class="headline">
        Vergleichen Sie 3 Tarife miteinander
      </v-card-title>

      <v-card-text>
        <v-alert
          v-if="sharedDataStore.isMobile()"
          border="top"
          colored-border
          type="info"
          elevation="2"
        >
          Drehen Sie bitte Ihr Handy um diesen Vergleich vollständig nutzen zu
          können.
        </v-alert>

        <v-table class="my-table">
          <thead>
            <tr>
              <th style="font-size: 14px">Tarif</th>
              <th style="width: 300px; font-size: 14px" class="blue--text">
                {{ tarif1.un_name }} {{ tarif1.tarif_title }}
              </th>
              <th style="width: 300px">
                <select
                  class="blue--text"
                  style="padding-left: 4px; font-size: 14px"
                  @change="pushTarifToVergleich($event, 2)"
                >
                  <option value selected>Tarif 2 wählen</option>
                  <option
                    style="padding-left: 10px"
                    v-for="tarif2 in alletarifeFiltered"
                    :value="tarif2.tarif_id"
                    :key="tarif2.tarif_id"
                  >
                    {{ tarif2.un_name }} {{ tarif2.tarif_title }}
                  </option>
                </select>
              </th>
              <th style="width: 300px">
                <select
                  class="blue--text"
                  style="padding-left: 4px; font-size: 14px"
                  @change="pushTarifToVergleich($event, 3)"
                >
                  <option value selected>Tarif 3 wählen</option>
                  <option
                    style="padding-left: 10px"
                    v-for="tarif3 in alletarifeFiltered"
                    :value="tarif3.tarif_id"
                    :key="tarif3.tarif_id"
                  >
                    {{ tarif3.un_name }} {{ tarif3.tarif_title }}
                  </option>
                </select>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Monatlicher Beitrag</td>
              <td v-for="tarif in tarifs" :key="tarif.tarif_id">
                <template v-if="tarif">
                  <strong>{{ tarif.preis_value }} €</strong>

                  <span v-if="tarif.empfehlung_type == 3"
                    >| Empfehlung "beste Leistung"</span
                  >
                  <span
                    v-if="
                      tarif.empfehlung_type == 1 || tarif.empfehlung_type == 2
                    "
                    >| Alternativ-Empfehlung
                  </span>

                  <span v-if="tarif.zuschlag_sehhilfen > 0"
                    ><br />inkl.
                    {{ tarif.zuschlag_sehhilfen }}
                    Zuschlag für Sehhilfen</span
                  >
                </template>
              </td>
            </tr>
            <tr>
              <td>
                <strong class="pb-0 mb-0">Infopaket</strong>
                <br />
                <span class="caption m">kostenlos</span>
              </td>
              <td v-for="tarif in tarifs" :key="tarif.tarif_id">
                <template v-if="tarif">
                  <v-btn
                    v-if="tarif.antraglink"
                    :href="tarif.antraglink"
                    :color="berechnung.fontColorVue"
                    style="color: white !important"
                    class="button_caps mt-1"
                  >
                    Antrag & Infopaket
                    <sup v-if="tarif.empfehlung_type > 0" class="white--text"
                      >Tipp</sup
                    >
                  </v-btn>
                </template>
              </td>
            </tr>

            <!-- Wartezeiten -->
            <tr>
              <td>
                <strong>Wartezeiten</strong><br />
                <span class="caption">Vertragsbedingungen</span>
              </td>
              <td
                v-for="tarif in tarifs"
                :key="tarif.tarif_id + '_wartezeiten'"
              >
                <span v-if="tarif.bri_wartezeit">{{
                  tarif.bri_wartezeit
                }}</span>
                <span v-else>Keine Wartezeit</span>
              </td>
            </tr>
            <tr>
              <td>
                <strong class="pb-0 mb-0">Erstattung</strong>
                <br />
                <span class="caption">bei Heilpraktiker</span>>
              </td>
              <td
                v-for="tarif in tarifs"
                :key="tarif.tarif_id + '-sonnenbrillen'"
              >
                {{ tarif.hp_naturheilkunde_heilpraktiker }}
              </td>
            </tr>

            <!-- Zeile für Erstattung für Gleitsichtbrille -->
            <tr>
              <td>
                <strong class="pb-0 mb-0">Erstattung</strong>
                <br />
                <span class="caption">bei Naturheilkunde-Arzt</span>
              </td>
              <td v-for="tarif in tarifs" :key="tarif.tarif_id + '-gleitsicht'">
                {{ tarif.hp_naturheilkunde_arzt }}
              </td>
            </tr>

            <!-- Zeile für Erstattung für Kontaktlinsen -->
            <tr>
              <td><strong>Begrenzungen</strong></td>
              <td
                v-for="tarif in tarifs"
                :key="tarif.tarif_id + '-kontaktlinsen'"
              >
                {{ tarif.hp_begrenzungen_hp }}
              </td>
            </tr>

            <!-- Zeile für Erstattung für Prismenbrille -->
            <tr>
              <td><strong>Wartezeit</strong></td>
              <td
                v-for="tarif in tarifs"
                :key="tarif.tarif_id + '-prismenbrille'"
              >
                {{ tarif.hp_wartezeit }}
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
  import { ref, onMounted, watch, reactive, computed, defineProps } from "vue";
  import { useSharedDataStore } from "@/stores/sharedData";
  const sharedDataStore = useSharedDataStore();
  // Props declaration with defineProps if needed in <script setup>
  const props = defineProps(["tarif1", "alletarife", "berechnung"]);
  console.log(props.tarif1.tarif_id);
  // State and reactivity
  //   const showSofortPop1 = ref(false);
  //   const showSofortPop2 = ref(false);
  //   const showSofortPop3 = ref(false);
  //   const valueSelected = ref(0);
  //   const tarifNrSelected = ref(0);
  const alletarifeFiltered = ref([]);
  // const showTable = ref(false);
  const showColspan = ref(2);

  const state = reactive({
    select: {
      tarif_id: props.tarif1.tarif_id,
      action: "beitragsentwicklung",
      berechnung: props.berechnung,
      tarif: props.tarif1,
    },
    tarif2: null, // Corrected to 'null'
    tarif3: null, // Corrected to 'null'
  });

  const tarifs = computed(() => {
    let tarifsArray = [props.tarif1]; // Start with tarif1 always present
    if (state.tarif2 !== null) {
      tarifsArray.push(state.tarif2); // Add tarif3 only if tarif2 is present and tarif3 itself is not null
    }
    if (state.tarif3 !== null) {
      tarifsArray.push(state.tarif3); // Add tarif3 only if tarif2 is present and tarif3 itself is not null
    }

    return tarifsArray;
  });

  // Equivalent of the created lifecycle hook
  onMounted(() => {
    filterAlle();
  });

  // Methods
  function filterAlle() {
    alletarifeFiltered.value = props.alletarife.filter(
      (x) => x.tarif_id !== parseInt(props.tarif1.tarif_id)
    );
  }

  function pushTarifToVergleich(event, tarif_nr) {
    if (tarif_nr === 2) {
      const treffer2 = props.alletarife.filter(
        (x) => parseInt(x.tarif_id) === parseInt(event.target.value)
      );
      state.tarif2 = treffer2[0];
    } else if (tarif_nr === 3) {
      const treffer3 = props.alletarife.filter(
        (x) => parseInt(x.tarif_id) === parseInt(event.target.value)
      );
      state.tarif3 = treffer3[0];
    }
  }
  watch(
    () => tarifs.value.length, // This is the source reactive property to watch
    (newLength) => {
      showColspan.value = newLength + 1;
    },
    {
      immediate: true, // This option will trigger the handler immediately with the current value
    }
  );
</script>

<style>
  .my-table td {
    vertical-align: top;
  }
</style>
